/**
 * CombinedDeliveryDeals
 * 묶음배송 상품 리스트
 */
export default class CombinedDeliveryDeals {
  constructor() {
    const {
      data: { COMBINED_DELIVERY_DEALS = {} } = {},
    } = TMON.oApp.htStorage.intergratedDeals;

    if (!Object.keys(COMBINED_DELIVERY_DEALS).length) return;

    /* 묶음상품 */
    const { itemList, partnerUrl } = COMBINED_DELIVERY_DEALS;
    this.itemList = itemList;
    this.partnerUrl = partnerUrl;
    this.setEvent();
  }

  getCombineInfo() {
    if (this.itemList) {
      const info = {
        floatYn: '',
        containerRole: '_wrapCombinedDeliveryContainer',
        strongWord: '묶음 배송',
        strongClass: 'point_highlight',
        h4Word: ['', '판매자의 다른 상품도 함께 주문하세요.'],
        spanWord: '묶음 배송',
        spanClass: 'point_highlight',
        mobileH4Word: ['', '판매자의 다른 상품도 함께 주문하세요.'],
        landingUrl: this.partnerUrl,
        listRole: '_wrapCombinedDeliveryDeals',
        tlCode: 'BDPT',
        dataSize: this.itemList.length,
        itemList: this.itemList,
        aTagDataRole: 'goCombinedDeliveryDeallist',
        aSpanWord: '묶음배송 가능 상품',
        key: 'combineDelivery',
      };
      return info;
    }
    return {};
  }

  setEvent() {
    $('body').on('click', '[data-role=goCombinedDeliveryDeallist]', e => {
      this.goCombinedDeliveryDeallist(e);
    });
  }

  clearEvent() {
    $('body').off('click', '[data-role=goCombinedDeliveryDeallist]');
  }

  goCombinedDeliveryDeallist(e) {
    if (TMON.view_mode === 'app') {
      e.preventDefault();
      try {
        TMON.app.callApp(
          'webview',
          'goBundledDelivery',
          `${TMON.oApp.htStorage.htStaticData.htDealInfo.deliveryInfo.combinedDeliveryPolicyNo}`,
          `${TMON.oApp.htStorage.htStaticData.htDealInfo.partnerNo}`
        );
      } catch (err) {
        console.error(err);
        alert(
          '일시적인 오류로 묶음배송 상품 조회에 실패하였습니다. 잠시 후 다시 시도해 주십시오. 문제가 지속되면 고객센터로 문의를 부탁드립니다.'
        );
      }
    }
  }
}
